import React, { useEffect, useState } from "react";
import api from "../lib/api";

export default function TraderBadge({ userId, showInfo = false }) {
  const [badge, setBadge] = useState(null);

  useEffect(() => {
    if (!userId) return;
    api.get("/trading/badge/" + userId).then((r) => setBadge(r.data)).catch(() => {});
  }, [userId]);

  if (!badge) return null;

  return (
    <span className="inline-flex items-center gap-1 text-xs font-mono bg-[var(--bg-elevated)] border border-[var(--border-soft)] rounded-full px-2.5 py-1">
      {badge.label}
      {showInfo && <span className="text-[var(--text-tertiary)]">({badge.win_rate}% · {badge.total_trades} trades)</span>}
    </span>
  );
}